import { testimonialsMason } from '../../../mocks/journey';

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 sm:py-32 bg-[#0d0d0d] relative" aria-label="Customer testimonials and success stories">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c8a96e]/15 to-transparent" />

      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-px bg-[#c8a96e]" />
          <span className="text-[#c8a96e] text-xs font-black tracking-[0.3em] uppercase">Real Results</span>
        </div>

        <div className="mb-12 sm:mb-16 max-w-xl">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-tight mb-4">
            People Who<br />
            <span className="text-[#c8a96e]">Did The Work</span>
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            These aren't paid testimonials. These are real people who followed the programs and put in the effort.
          </p>
        </div>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonialsMason.slice(0, 3).map((testimonial) => (
            <article key={testimonial.id} className="bg-[#111111] border border-white/6 rounded-sm p-6 flex flex-col">
              {/* Stars */}
              <div className="flex items-center gap-1 mb-5">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#c8a96e] text-xs" />
                  </span>
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-sm text-gray-300 leading-[1.8] mb-7 flex-1">
                "{testimonial.quote}"
              </blockquote>

              {/* Person — no avatar */}
              <div className="pt-5 border-t border-white/5">
                <cite className="not-italic">
                  <div className="text-white font-bold text-sm mb-0.5">{testimonial.name}</div>
                  <div className="text-[#c8a96e] text-xs font-semibold tracking-wide">{testimonial.detail}</div>
                </cite>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}